$(document).ready(function(){
	
	$(document).on("click touchstart", '.comments_toggle', function (e) {
		var $this = $(this);
		if($this.hasClass('closed')){
			getComments($this.data('rel'));
			$this.html('<i class="icon-caret-up"></i> Close Comments');
			$this.removeClass('closed');
			$this.addClass('opened');
			
		} else {
			$this.html('<i class="icon-caret-down"></i> Open Comments');
			$this.removeClass('opened');
			$this.addClass('closed');
			$this.parent('div').next('.comments_inner_wrapper').slideUp('slow', function(){
				$(this).empty();
			})
		}
		return false;
	});
	
	$(document).on("click", '.comments_open', function (e) {
		if($(this).hasClass('opened')){
			return false;
		}else{
			getComments($(this).data('rel'));
			$(this).addClass('opened');
		}
		return false;
	});
	
	$(document).on("click touchstart", '.reply-to-comment', function (e) {
		var the_form = $('form[name="comments_form"]:first').clone(false);
		var the_container = $(this).closest('.comment').find('.reply-form-container');
		var the_post = $(this).data('id');
		$('.reply_to_comment_form').remove();
		the_container.append('<div class="reply_to_comment_form" style="display:none"></div>');
		the_container.find('.reply_to_comment_form').html(the_form);
		the_container.find('input[name="reply_to"]').val(the_post);

        the_container.find('.btn').text('Απάντηση');

		$('.reply_to_comment_form').fadeIn('fast');

        initCommentsForm('.reply_to_comment_form form');

		return false;	
	});	
});

function initCommentsForm(target){
	$(target).addClass('ready');
	$(target).validate({
		rules: {
			'posted_by':'required',
			'comment':'required'
		},
		messages:{
			'posted_by':'!',
			'comment':'!'
		},
		submitHandler: function() {
			$.ajax({data:$(target).serialize(),success:function(data){
				if(data.status == 'ok'){
					$(target).find('input:text').val('');
					$(target).find('textarea').val('');
					setTimeout(function(){
					    filter('comments');
					},500)
				}else if(data.status == 'error') {
					form_submit_response(target,'danger',data.error);
				}else{
					form_submit_response(target,'danger','An unknown error occurred. Please contact support@fnl-guide.com');
				}
			}});
		}
	});
}
function getComments(rel){
	var target = $('#comments-list[data-rel="'+rel+'"]'),
		feed = target.data('feed');
	target.load(feed,function(){
		$(this).slideDown('slow');
		scroll2element($(this));
	});
}
